// Timezone option labels follow "Pacific Standard Time (PST)"; the pill reuses
// the same parenthetical abbreviation so it stays consistent with the dropdown.
export const getTimezoneAbbreviation = (label: string): string | undefined =>
  label.match(/\(([^)]+)\)/)?.[1];
